const initGiftPackageStickyEffect = () => {
  //if screen > 1024px (lg breakpoint) : apply the sticky-like effect to the add to cart form
  //otherwise, the booking form should be static with an auto width
  if(window.matchMedia("(min-width: 1024px)").matches){
    const addToCartForm = document.getElementById('add-to-cart-form-container');
    const initialWidth = addToCartForm.clientWidth;

    const collisionDiv = document.getElementById('collision-block');
    if(!collisionDiv){
      return;
    }

    let offset = 100;
    let initialOffsetTop = addToCartForm.offsetTop;
    window.addEventListener('scroll', function() {
      if(window.matchMedia("(min-width: 1024px)").matches){
        let scrollY = window.scrollY;
        // Get the collision div's position relative to the document
        let collisionRect = collisionDiv.getBoundingClientRect();
        let collisionTop = collisionRect.top + window.scrollY - addToCartForm.offsetHeight - offset;

        // Add some padding to prevent overlap
        collisionTop -= 50;

        if (scrollY > initialOffsetTop && scrollY <= collisionTop) {
          addToCartForm.style.position = 'absolute';
          addToCartForm.style.top = scrollY + 'px';
        }
        else if(scrollY <= initialOffsetTop){
          addToCartForm.style.position = 'absolute';
          addToCartForm.style.top = '0px';
        }
        else {
          addToCartForm.style.position = 'absolute';
          addToCartForm.style.top = collisionTop + 'px';
        }
      }
    });

    window.dispatchEvent(new Event('scroll'));

    window.addEventListener('resize', () => {
      if(!(window.matchMedia("(min-width: 1024px)").matches)){
        addToCartForm.style.width = 'auto';
        addToCartForm.style.position = 'static';
      }
      else{
        addToCartForm.style.width = '100%';
      }
    });
  }
}

export { initGiftPackageStickyEffect }
